module.exports = __webpack_public_path__ + "static/media/logo_SPH.f1e2a539.PNG";